module.exports = __webpack_public_path__ + "static/img/qt_2.a990920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/qt_2.png
// module id = l6R/
// module chunks = 1